import { render, staticRenderFns } from "./ToInvoiceProformaDialog.vue?vue&type=template&id=f412b3ac&scoped=true"
import script from "./ToInvoiceProformaDialog.vue?vue&type=script&lang=js"
export * from "./ToInvoiceProformaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f412b3ac",
  null
  
)

export default component.exports